// extracted by mini-css-extract-plugin
module.exports = {"userMenuContainer":"UserMenu_userMenuContainer__rJnFN","separator":"UserMenu_separator__xYkEh"};